module.exports = __webpack_public_path__ + "img/2.b4dff3b6.png";